import React from 'react';
import { Card, Table, Button, Badge } from 'react-bootstrap';
import { FaPlay, FaTrash } from 'react-icons/fa';

import {
  BANCO_ORIGEM_LABEL,
  STATUS_SESSAO_LABEL,
  formatDataHoraBR,
} from '../helpers';

const ListaSessoes = ({ sessoes, onRetomar, onDescartar, loading }) => {
  if (!sessoes || sessoes.length === 0) {
    return (
      <Card className="mb-3">
        <Card.Body className="text-muted text-center small py-3">
          Nenhuma sessão em revisão. Importe um arquivo CNAB para iniciar.
        </Card.Body>
      </Card>
    );
  }

  return (
    <Card className="mb-3">
      <Card.Header as="h6" className="bg-light">
        Sessões em revisão ({sessoes.length})
      </Card.Header>
      <div className="table-responsive">
        <Table striped bordered hover size="sm" className="mb-0">
          <thead>
            <tr>
              <th>Código</th>
              <th>Empreendimento</th>
              <th>Banco</th>
              <th>Arquivo</th>
              <th>Data importação</th>
              <th className="text-right">Movimentos</th>
              <th>Status</th>
              <th className="text-center">Ações</th>
            </tr>
          </thead>
          <tbody>
            {sessoes.map((s) => (
              <tr key={`sessao-${s.codigo}`}>
                <td>{s.codigo}</td>
                <td>
                  {s.codigo_grupo_empresa}
                  {s.apelido_ge ? ` - ${s.apelido_ge}` : ''}
                </td>
                <td>
                  {BANCO_ORIGEM_LABEL[s.banco_origem]
                    ? `${s.banco_origem} - ${BANCO_ORIGEM_LABEL[s.banco_origem]}`
                    : s.banco_origem}
                </td>
                <td>{s.arquivo_nome}</td>
                <td>{formatDataHoraBR(s.data_importacao)}</td>
                <td className="text-right">{s.total_movimentos}</td>
                <td>
                  <Badge variant="warning">
                    {STATUS_SESSAO_LABEL[s.status] || s.status}
                  </Badge>
                </td>
                <td className="text-center">
                  <Button
                    variant="primary"
                    size="sm"
                    className="mr-1"
                    onClick={() => onRetomar && onRetomar(s)}
                    disabled={loading}
                    title="Retomar sessão"
                  >
                    <FaPlay /> Retomar
                  </Button>
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => onDescartar && onDescartar(s)}
                    disabled={loading}
                    title="Descartar sessão"
                  >
                    <FaTrash />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </Card>
  );
};

export default ListaSessoes;
